import React from "react";
import PropTypes from "prop-types";
import {Helmet} from "react-helmet";
import Header from './header';
import Footer from './footer';
import CategoriesWidget from '../components/CategoriesWidget';
import TagsWidget from '../components/TagsWidget';
import QuickSearch from '../components/QuickSearch';
import "./style.css";
import "./style.overwrite.css";
require('typeface-nunito-sans');
require('typeface-poppins');

class DefaultLayout extends React.Component {
  componentDidMount() {
    // one-time init of the embedly platform.js, hidden behind 
    // typeof check not to blow up on server-side render
    if (typeof window !== 'undefined') {
      const init_embedly = function (w, d) {
        var id = 'embedly-platform', n = 'script';
        if (!d.getElementById(id)) {
          w.embedly = w.embedly || function () { (w.embedly.q = w.embedly.q || []).push(arguments); };
          var e = d.createElement(n); e.id = id; e.async = 1;
          e.src = ('https:' === document.location.protocol ? 'https' : 'http') + '://cdn.embedly.com/widgets/platform.js';
          var s = d.getElementsByTagName(n)[0];
          s.parentNode.insertBefore(e, s);
        }
      }
      init_embedly(window, document)
    }
  }

  render() {
    return (
      <div className="tong home blog hfeed header-layout1 content-sidebar">
        <div className="site">
          <Header {...this.props} />
          <Helmet>
              <meta charSet="utf-8" />
              <meta name="description" content={this.props.data.contentfulSiteSettings.description} />
              <title>{this.props.data.contentfulSiteSettings.title}</title>
          </Helmet>
          <div className="site-content">
            <div className="container">
              <div className="inside">
                <div id="primary" className="content-area">
                  <main className="site-main" role="main">
                    {this.props.children()}
                  </main>
                </div>
                <aside id="secondary" className="sidebar widget-area" role="complementary">
                    <CategoriesWidget {...this.props.data.allContentfulCategory} />
                </aside>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

DefaultLayout.propTypes = {
  location: PropTypes.object.isRequired
};

export default DefaultLayout;

export const query = graphql`
  query HeaderImageQuery {
    contentfulSiteSettings {
      headingImage {
        sizes(maxWidth: 1400) {
          ...GatsbyContentfulSizes
        }
      }
      title
      description
    }
    allContentfulCategory(sort: {fields: [name]}) {
        edges {
            node {
              id
              name
              slug
              blog_post {
                id
              }
            }
        }
    }
    allContentfulTag(sort: {fields: [name]}) {
        edges {
            node {
              id
              name
              slug
              blog_post {
                id
              }
            }
        }
    }
}
`;


// WEBPACK FOOTER //
// ./src/layouts/index.js